
import {SaveButton} from "../../../components/SaveButton";

export default {
    init() {
        this.getServicesModal();
        this.getActionServiceModal();
        this.templateDelete();
        this.templateEdit();
        this.templateUpdate();
        this.templateView();
        this.initFormActions();
        this.sortServices();
        this.dropDownField();
    },
    getServicesModal() {
        let _this = this;
        $('.services-list__table-controls-button-add').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/services-management/services/get-form',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#product-modal').modal('show');
                    _this.initServiceAdd();
                    Livewire.restart();
                }
            });
        });
    },
    getActionServiceModal() {
        let _this = this;
        $('.services-list__table-controls-row-item').click(function (e) {
            let action = $(this).data('action');
            if (action == 'delete')
                return true;

            e.preventDefault();

            let product_id = $(this).data('product-id');
            let category_id = $(this).data('category-id');
            if (action) {
                switch (action) {
                    case 'edit':
                        $.ajax({
                            type: 'GET',
                            url: '/services-management/services/get-form',
                            data: {
                                product_id
                            },
                            success: function (response) {
                                $('#form-container').html(response);
                                $('#product-modal').modal('show');
                                _this.initServiceAdd();
                                _this.getServicesSorted();
                                Livewire.restart();
                            }
                        });
                        break;
                    case 'view':
                        $.ajax({
                            type: 'GET',
                            data: {
                                product_id
                            },
                            url: '/services-management/services/get-complete-form/' + category_id,
                            success: function (response) {
                                $('#form-container').html(response);
                                $('#service-request-modal').modal('show');

                                Livewire.rescan();
                                Livewire.emit('getSelectedService', product_id);
                                Livewire.emit('categoriesHidden');

                            }
                        });
                        break;
                }
            }
        });
    },
    initServiceAdd() {
        $('#service-submit-form').click((e) => {
            this.SaveBtn = new SaveButton();
            e.preventDefault();
            //let data = $('#product-form').serialize();
            let data = new FormData($('#product-form')[0]);
            if($('input[name=tax_exempt]:checked').length)
                data.delete('tax_id')
            
            const selectedWorkers = $(`#product-form .bb-workers-select .worker-row input[type=checkbox]:checked`);
            for (let selectedWorker of selectedWorkers) {
                data.append('workers[]', $(selectedWorker).attr('id'));
            }
            //console.log(data.get()); return;
            $.ajax({
                type: 'POST',
                url: '/services-management/services/save-service',
                data: data,
                processData: false,
                contentType: false,
                beforeSend: () => {
                    this.SaveBtn.startLoading();
                },
                success: () => {
                    this.SaveBtn.stopLoading().then(
                        () => {
                            this.SaveBtn.showSuccess().then(
                                function () {
                                    $('#product-modal').modal('hide');
                                    $('#product_table #table').DataTable().ajax.reload(null, false);
                                }
                            )
                        }
                    );
                },
                error: (response) => {
                    this.SaveBtn.stopLoading().then(() => this.SaveBtn.showError())
                        
                    /* let errorsHtml = '<div class="alert alert-danger">';
                    if (response.responseJSON.error) {
                        errorsHtml += response.responseJSON.error;
                    }
                    if (response.responseJSON.errors) {
                        errorsHtml += 'Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errorsHtml += '<li>' + value + '</li>';
                        });
                        errorsHtml += '</ul>';
                    }
                    errorsHtml += '</div>';
                    $('.product-form-wrapper .form-validation-errors').html(errorsHtml); */
                }
            });
        });
    },
    getServicesSorted() {
        let _this = this;
        if ($('.product-modal__product-input:checked').length <= 1)
            return false;

        $('.product-modal__sort-button').click(function (e) {
            e.preventDefault();
            if ($(this).hasClass('sort_disabled'))
                return false;

            let action = $(this).data('sort-direction');
            let modifierId = $(this).parent().data('sort-for');
            let productId = $(this).parent().data('product-id');

            $.ajax({
                type: 'GET',
                url: '/services-management/services/get-inner-form',
                data: {
                    action,
                    productId,
                    modifierId
                },
                success: function (response) {
                    $('.product-modal__body').html(response);
                    _this.getServicesSorted();
                }
            });

        });
    },
    recordsToShowChange() {
        let _this = this;
        $('select[name="records_to_show"]').change(function (e) {
            let form = $(this).parents('form');
            if (form)
                form.submit();
        });
    },
    initProductDeletes() {
        $('.services-list__table-controls-row-item[data-action="delete"]').click(function () {
            let serviceId = $(this).data('product-id');
            if (confirm('You sure want to delete this?')) {
                $.ajax({
                    type: 'get',
                    url: '/delete-service/' + serviceId,
                    success: function () {
                        $('#product_table #table').DataTable().ajax.reload(null, false);
                    }
                });
            }
        })
    },

    templateEdit() {
        $('#sub-container').on('click', '.template-edit-btn', function (e) {
            let templateId = e.target.getAttribute('data-template-id')

            $.ajax({
                type: 'GET',
                url: `/jobs-flow/template/${templateId}/edit`,

                success: (response) => {
                    $('#sub-container').html(response);
                    $('#checklist-template-form-modal').modal('show');

                    const formId = $('#checklist-template-form-modal').find('.template-edit-form').attr('id');
                    $('#checklist-template-form-modal [data-dismiss="modal"]').on('click', '.close-btn', () => {
                        window.close()
                    });
                    $('#checklist-template-form-modal .add-another-line').on('click', () => {
                        addTemplateLine(formId)
                        if ($('#checklist-template-form-modal').find('.item').length != 1) {
                            $('.remove-line').removeClass('unvisible')
                        }
                    });
                    $('#checklist-template-form-modal').on('click', '.remove-line', (e) => {
                        removeTemplateLine(e.target)
                        if ($('#checklist-template-form-modal').find('.item').length == 1) {
                            $('.remove-line').addClass('unvisible')
                        }

                    })
                }
            })

            function checkTemplateRowCount() {
                if($(`#sub-container`).find('.item').length == 1) {
                    $(`#sub-container`).find('.item').find('.remove-line').addClass('unvisible');
                } else {
                    $(`#sub-container`).find('.item').find('.remove-line').removeClass('unvisible');
                }
            }

           function addTemplateLine(formId) {
                $(`#${formId}`).append(window.formLine);
                checkTemplateRowCount();
            }

            function removeTemplateLine(target) {
                const formId = $(target).parents('form').attr('id');
                $(target).parents('.item').remove();

                checkTemplateRowCount();
            }

        })
    },

    templateDelete() {
        $('#sub-container').on('click', '.template-delete-btn', (e) => {
            let templateId = e.target.getAttribute('data-template-id')
            $.ajax({
                method: 'DELETE',
                url: `/jobs-flow/template/${templateId}`,

                success: function (response) {
                    $('#checklist-templates-modal').modal('hide')
                    $('#product-modal').modal('hide')

                }
            });

        });
    },
    templateUpdate() {
        $('#sub-container').on('click', '.update-template-btn', (e) => {
            let templateId = e.target.getAttribute('data-template-id')
            const template_title = $('#sub-container').find('#template_title').val()
            let userData = {
                items: [],
            }

            const items = $(`#sub-container .item`);
            for (let item of items) {
                const itemJQ = $(item);
                if (itemJQ.find(`[name=title]`).val().trim().length > 0 && itemJQ.find(`[name=details]`).val().trim().length > 0) {
                    userData.items.push({
                        id: itemJQ.find(`[name=item_id]`).val(),
                        title: itemJQ.find(`[name=title]`).val().trim(),
                        details: itemJQ.find(`[name=details]`).val().trim()
                    });
                }
            }

            $.ajax({
                url: `/jobs-flow/template/${templateId}/update`,
                type: "POST",
                data: {userData, template_title},
                success: function (data) {
                    $('#checklist-template-form-modal').modal('hide');
                    $('#checklist-templates-modal').modal('hide');
                    $('#product-modal').modal('hide')


                },
                error: function (msg) {
                    $('#checklist-template-form-modal').modal('hide');
                }
            });


        });

    },

    templateView() {
        $('#form-container').on('click', '.template-view', (e) => {
            let template_create_button = e.target.getAttribute('data-template-create_button')
            let template_hide_use_as = e.target.getAttribute('data-template-hide_use_as')
            let template_type = e.target.getAttribute('data-template-type')

            $.ajax({
                type: 'GET',
                url: `/jobs-flow/template/show/${template_type}`,
                data: {
                    'template_create_button': template_create_button,
                    'template_hide_use_as': template_hide_use_as
                },
                success: (response) => {
                    $('#sub-container').html(response);
                    $('#checklist-templates-modal').modal('show');
                }
            });

        })
    },

    initFormActions(){
        $('body').on('click', '#service_tax_check', function() {
            if ($(this).is(':checked')) {
                $('.tax-container').addClass('d-none');
            }else{
                $('.tax-container').removeClass('d-none');
            }
        });

        $('body').on('click', '#service_payment_check', function() {
            if ($(this).is(':checked')) {
                $('.tips-block').removeClass('d-none');
                $('.tax-block').removeClass('d-none');
            } else {
                $('.tips-block').addClass('d-none');
                $('.tax-block').addClass('d-none');
            }
        });

        $('body').on('click', '#checklist_select_show', function() {
            if ($(this).is(':checked')) {
                $('.checklist-select').removeClass('d-none');
            }else{
                $('.checklist-select').addClass('d-none');
                $('select [name="checklist_template_id"]').val('')
            }
        });

    },

    sortServices(){
        $('body').on('click','.sort-service-btn',function(e) {
            if ($(this).hasClass('disabled')) {
                return;
            }

            const direction = $(this).data('sort-direction');
            const service_id =  $(this).data('service-id');
            const page = new URLSearchParams(window.location.search).get('page');

            $.ajax({
                method: 'POST',
                url: '/services-management/services/sort-service',
                data: {
                    service_id: service_id,
                    direction: direction,
                    page: page,
                },
                success: (response) =>{
                    //window.location.reload(true);
                    $('.services_table_container').html(response);
                },
                error: (response)=>{

                }

            })

        });
    },

    dropDownField(){
        $('body').off('click', '.dropdown-field-title')
        .on('click', '.dropdown-field-title', function(e) {
            const dropDown = $(this).parent();
            if ($(dropDown).find('.dropdown-field-content').hasClass('opened')) {
                $(dropDown).find('.dropdown-field-content').removeClass('opened');
                $(this).find('.dropdown-field-arrow').removeClass('opened');
            } else {
                $('.dropdown-field-content.opened').removeClass('opened');
                $('.dropdown-field-arrow').removeClass('opened');
                $(dropDown).find('.dropdown-field-content').addClass('opened');
                $(this).find('.dropdown-field-arrow').addClass('opened');
            }
        });
    }
}
